(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiread4b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiread4b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3tig5", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $28723e44681442b6$export$6503ec6e8aabbaf; }, function (v) { return $28723e44681442b6$export$6503ec6e8aabbaf = v; });
var $28723e44681442b6$export$6503ec6e8aabbaf;
var $28723e44681442b6$export$f7ad0328861e2f03;
"use strict";
var $28723e44681442b6$var$mapping = new Map();
function $28723e44681442b6$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$28723e44681442b6$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $28723e44681442b6$var$resolve(id) {
    var resolved = $28723e44681442b6$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$28723e44681442b6$export$6503ec6e8aabbaf = $28723e44681442b6$var$register;
$28723e44681442b6$export$f7ad0328861e2f03 = $28723e44681442b6$var$resolve;

});

parcelRegister("hKR6R", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $cecfedfe58011b9b$export$bdfd709ae4826697; }, function (v) { return $cecfedfe58011b9b$export$bdfd709ae4826697 = v; });
var $cecfedfe58011b9b$export$bdfd709ae4826697;
var $cecfedfe58011b9b$export$c9e73fbda7da57b6;
var $cecfedfe58011b9b$export$5a759dc7a1cfb72a;
"use strict";
var $cecfedfe58011b9b$var$bundleURL = {};
function $cecfedfe58011b9b$var$getBundleURLCached(id) {
    var value = $cecfedfe58011b9b$var$bundleURL[id];
    if (!value) {
        value = $cecfedfe58011b9b$var$getBundleURL();
        $cecfedfe58011b9b$var$bundleURL[id] = value;
    }
    return value;
}
function $cecfedfe58011b9b$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $cecfedfe58011b9b$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $cecfedfe58011b9b$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $cecfedfe58011b9b$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$cecfedfe58011b9b$export$bdfd709ae4826697 = $cecfedfe58011b9b$var$getBundleURLCached;
$cecfedfe58011b9b$export$c9e73fbda7da57b6 = $cecfedfe58011b9b$var$getBaseURL;
$cecfedfe58011b9b$export$5a759dc7a1cfb72a = $cecfedfe58011b9b$var$getOrigin;

});

var $a029e396498b2fcb$exports = {};


(parcelRequire("3tig5")).register((parcelRequire("hKR6R")).getBundleURL("cieZu"), JSON.parse('["cieZu","index.9ce49b59.js","87FOq","favicon.d9e83296.png","eNawi","food.6f2bb2b7.png","2EvTd","homun_bkgd1.dc65ddf5.png","9AEI8","glass_panel.3b633db2.png","9rN51","card_glow.56d7d7ac.png","4iZfW","card_glow_red.54387d9a.png","lBkZR","card_background.ee819a66.png","7qpBu","nails.b8a82ee1.png","hFq3d","card_background_decor.d8943715.png","iAf32","handy.7fa8b49b.png","9rKmo","card_background_eat.185113bf.png","9Z7HC","card_background_eat_2.0c01bd5c.png","8Qr1B","event_background.c96961a2.png","cz64n","homunculus4.24f4773c.png","7JuFV","homunculus2.610c62d2.png","aVOlm","card_image.a1799d09.png","4vhMf","card_gold.e20cb56b.png","a3qrr","card_money.e4169829.png","5JryI","card_medicine.57060ec9.png","dCSEC","card_corpse.7a9441f6.png","leRQw","card_merchant.218ba203.png","aPpcj","card_the_rough_kind.a675137c.png","f6AYT","card_shadow_muse.80e2a354.png","Uiu6F","card_the_law.e8ec7c95.png","jbJLh","card_sonechka.6776773d.png","9DLOU","card_the_id.ead336b2.png","fP0yM","card_poison.aa5e7401.png","apCad","card_poison_mold.0520f702.png","2xLg5","card_alchemical_supplies.ee326987.png","hbGpS","card_booze.75b3438e.png","gsJDf","card_explosives.7fe360e7.png","DJFeW","singing_mushrooms.1c1dcf72.png","iWJaW","the_portal.0541c92a.png","aRyfk","the_raid.c7bf5320.png","hs9lm","enlightened_mandrake.cfcb22bf.png","8djbj","watching_flower.336de1a6.png","iGmue","alchemical_reaction_off.f35b594c.png","2zKyG","alchemical_reaction_on.a5a3ad4b.png","jhDL9","1_explosion.d2d961b9.png","j4e5C","2_explosion.2a182204.png","2OaM9","3_explosion.649a91b3.png","1LoXB","4_explosion.7b338b58.png","9DLew","5_explosion.bb396357.png","eHwBH","small_heart.dd07f430.png","hChe3","small_food.f2edc31e.png","bPOLh","watch.1a0b31cc.png","fIyGR","cloud_1.32657c97.png","caDAf","cloud_2.2f85ac3c.png","aoTpk","cloud_3.95e3afc3.png","93bPS","cloud_4.ac5f61c0.png","5yJ83","1_blood.3bb09fa0.png","a2ZKB","2_blood.f6535194.png","jZC9b","3_blood.f69b8f28.png","hxWAw","chat_bubble.fc2f393a.png","gzZZ0","music_light.60cd5477.png","20X8m","main_menu.c49aa625.ogg","jeyE9","main_menu.221e6ed8.aac","4dzfN","board_theme_intro.42f7d77e.ogg","bO5rN","board_theme_intro.eead50fa.aac","7ihuX","board_theme_loop.704d9b63.ogg","lol12","board_theme_loop.eeb20248.aac","kgCCv","game_over_short.7204a955.ogg","7Hj58","game_over_short.28010dc6.aac","gMpmy","card_1.44b42c34.ogg","aDXyN","card_1.a68ac5b0.aac","6CeXP","card_2.2b774fd9.ogg","hXRil","card_2.fd3f5eae.aac","jkDzu","card_3.9cd717b7.ogg","2ypVF","card_3.db269ca7.aac","jOuRg","card_4.f58ff31d.ogg","fET07","card_4.8cab7261.aac","6r53i","bite_1.bf2a7fcd.ogg","aGWeb","bite_1.132e2a74.aac","eSZSh","bite_2.6b01b551.ogg","bvXbY","bite_2.f926aa89.aac","c5C6R","bite_3.b91f8fe4.ogg","aRpOm","bite_3.29963428.aac","lJctn","slash_splat_1.35f8ab53.ogg","5cTup","slash_splat_1.7f9c16a1.aac","4oNAM","slash_splat_2.6272c1ed.ogg","cqlJ5","slash_splat_2.875e32a1.aac","ayayg","poof.3ab94f61.ogg","4oUmU","poof.e7022e87.aac","Sqhor","light_up.32aa58ae.ogg","dFyG9","light_up.0cb1d715.aac","dptPF","put_out.c5eedcdc.ogg","fQpuY","put_out.f76fadcd.aac","azhMx","explosion.dcb03df3.ogg","jI7Lk","explosion.c1b7d453.aac"]'));

})();
//# sourceMappingURL=index.runtime.d85bf356.js.map
